import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconThumbsUp12Filled from './IconThumbsUp12Filled';
import IconThumbsUp12 from './IconThumbsUp12';
import IconThumbsUp16Filled from './IconThumbsUp16Filled';
import IconThumbsUp16 from './IconThumbsUp16';
import IconThumbsUp20Filled from './IconThumbsUp20Filled';
import IconThumbsUp20 from './IconThumbsUp20';
import IconThumbsUp24Filled from './IconThumbsUp24Filled';
import IconThumbsUp24 from './IconThumbsUp24';
import IconThumbsUp32Filled from './IconThumbsUp32Filled';
import IconThumbsUp32 from './IconThumbsUp32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconThumbsUp = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && props.filled && <IconThumbsUp12Filled {...props} />}
            {size === IconSize.Size12 && !props.filled && <IconThumbsUp12 {...props} />}
            {size === IconSize.Size16 && props.filled && <IconThumbsUp16Filled {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconThumbsUp16 {...props} />}
            {size === IconSize.Size20 && props.filled && <IconThumbsUp20Filled {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconThumbsUp20 {...props} />}
            {size === IconSize.Size24 && props.filled && <IconThumbsUp24Filled {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconThumbsUp24 {...props} />}
            {size === IconSize.Size32 && props.filled && <IconThumbsUp32Filled {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconThumbsUp32 {...props} />}
        </span>
    );
};
IconThumbsUp.displayName = 'FondueIconThumbsUp';

export default memo(IconThumbsUp);
